<template>
  <section
    class="featured-guides-container flex flex-col justify-center px-10 font-rubik"
    aria-labelledby="featured-guides-heading"
  >
    <h2 id="featured-guides-heading" class="featured-guides-text">FEATURED GUIDES</h2>

    <nav
      class="flex flex-row justify-end items-center gap-14"
      aria-label="Highlighted educational guides"
    >
      <!-- Buyers Guide -->
      <article
        class="guides-card-container w-full h-full flex flex-row justify-between items-center gap-5"
        role="button"
        tabindex="0"
        @click="goTo('/buyers-guide')"
        aria-label="Buyers Guide"
      >
        <img
          class="guides-card-img"
          src="@/images/header/dropdown-featured-guides-img-01.png"
          alt="Cover of Buyers Guide"
        />

        <div>
          <h3 class="guides-card-h3">Buyers Guide</h3>
          <p class="guides-card-p">
            Tips for buying a shipping container for countless applications.
          </p>
        </div>

        <a
          href="/buyers-guide"
          class="guides-card-btn"
          aria-label="Read Buyers Guide"
        >
          <img
            class="guides-card-btn-img"
            src="@/images/header/arrow_forward.svg"
            alt=""
            aria-hidden="true"
          />
        </a>
      </article>

      <!-- Renters Guide -->
      <article
        class="guides-card-container w-full h-full flex flex-row justify-between items-center gap-5"
        role="button"
        tabindex="0"
        @click="goTo('/renters-guide')"
        aria-label="Renters Guide"
      >
        <img
          class="guides-card-img"
          src="@/images/header/dropdown-featured-guides-img-02.png"
          alt="Cover of Renters Guide"
        />

        <div>
          <h3 class="guides-card-h3">Renters Guide</h3>
          <p class="guides-card-p">
            See why renting may be more beneficial than a purchase – or not.
          </p>
        </div>

        <a
          href="/renters-guide"
          class="guides-card-btn"
          aria-label="Read Renters Guide"
        >
          <img
            class="guides-card-btn-img"
            src="@/images/header/arrow_forward.svg"
            alt=""
            aria-hidden="true"
          />
        </a>
      </article>
    </nav>
  </section>
</template>

<script>
export default {
  methods: {
    goTo(path) {
      window.location.href = path
    }
  }
}
</script>

<style scoped>
.featured-guides-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f9f8f6;
}

.featured-guides-text {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.02em;
  color: #334155;
}

.guides-card-container {
  position: relative;
  border-radius: 6px;
  transition: background-color 100ms linear;
  cursor: pointer;
}

.guides-card-container:hover {
  background-color: #ece9e3;
}

.guides-card-container:hover .guides-card-h3 {
  color: #1f44f0;
}

.guides-card-img {
  width: 150px;
  height: 198px;
  object-fit: cover;
}

.guides-card-h3 {
  color: #334155;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.04em;
  margin-bottom: 8px;
}

.guides-card-p {
  color: #334155;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  padding-right: 10px;
}

.guides-card-btn {
  background-color: #3565fc;
  position: absolute;
  bottom: 20px;
  left: 25px;
  padding: 7px;
  border-radius: 20px;
  border: 1px solid 3565FC;
  opacity: 0%;
  transition: opacity 250ms linear, transform 250ms linear,
    background-color 250ms linear, border 250ms linear;
  transform: translateX(-50%);
}

.guides-card-btn:hover {
  background-color: #1f44f0;
}

.guides-card-container:hover .guides-card-btn {
  opacity: 100%;
  transform: translateX(0%);
}

.guides-card-btn-img {
  height: 25px;
  filter: brightness(0) invert(1);
}
</style>
